import styled from 'styled-components';

export const Family = styled.section`
  padding: 0 1rem 0 1rem;
`;

export const FamilyTitle = styled.h2`
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
  font-size: 2rem;

  &:before, &:after {
    content: "";
    flex: 1 1;
    border-bottom: 0.15rem solid;
    margin: auto;
  }
  &:before {
    margin-right: 0.5rem;
  }
  &:after {
    margin-left: 0.5rem;
  }
`;

export const FamilyProducts = styled.section``